/**
 * Created by u271521 on 6/15/2017.
 */
(function() {
  'use strict';
  angular.module('dnConfirmationMessage',['ngAnimate'])
    .directive('dnConfirmationMessage', ['$timeout', '$compile', function($timeout, $compile) {
      return {
        restrict: 'AE',
        controller: ['$attrs','$scope', '$timeout', '$q', function($attrs, $scope, $timeout, $q) {
          var cm = this;
          cm.$show = function(messageCode, messageType, timeout) {
            cm.$messageCode = messageCode;
            cm.$messageType = messageType ? 'alert-' + messageType : 'alert-success';
            cm.$showConfirmation = true;
            var deferred = $q.defer();
            if (timeout !== 0) {
              timeout = timeout || 4000;
              $timeout(function() {
                cm.$showConfirmation = false;
                $timeout(function() {
                  deferred.resolve();
                }, 1500);
              }, timeout);
            }
            return deferred.promise;
          };
          cm.$hide = function() {
            cm.$showConfirmation = false;
          };
        }],
        link: function($scope, element, attrs, ctrl) {
          var alias = attrs.confirmationMessage || 'dnConfirmationMessage';
          var useTranslation = attrs.useTranslation;
          $scope[alias] = ctrl;
          var e = $compile(angular.element('<div class="alert-box fade-top confirmation-message" ng-show="' + alias + '.$showConfirmation">' +
            '<div class="alert {{' + alias + '.$messageType}}"><strong>{{' + alias + '.$messageCode' +
            (useTranslation ? ' | translate' : '') + '}}</strong></div>' +
            '</div>'))($scope);
          element.append(e);
          element.on('$destroy', function() {
            $scope[alias] = undefined;
          });
        }
      };
    }]);
})();
